import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const InputContainer = styled.div`
  display: flex;
`;

export const InputSelectedBox = styled.i.attrs(({ checked }) => ({
  className: checked ? 'fa fa-check' : '',
}))`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.white};
`;

export const InputSelectedRadio = styled.div`
  position: absolute;
  top: 0px;
  border-radius: 50%;
  height: 13px;
  width: 13px;
  min-height: 13px;
  min-width: 13px;
  ${({ checked, isDarkMode }) =>
    checked &&
    css`
      color: ${isDarkMode ? colors.fsCyan : colors.checkmark};
      border: 2px solid ${isDarkMode ? colors.darkGray3 : colors.white};
    `}
`;

export const InputSelectionBox = styled.button`
  ${({ disabled, isDarkMode, radio }) =>
    css`
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      background: ${isDarkMode ? colors.darkGray3 : colors.white};
      border-radius: ${radio ? '50%' : '2px'};
    `};
  appearance: none;
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 17px;
  width: 17px;
  min-height: 17px;
  min-width: 17px;
  margin-top: 3px;
  border: 2px solid ${colors.gray2};
  ${({ checked, isDarkMode }) => {
    const color = isDarkMode ? colors.fsCyan : colors.checkmark;
    return (
      checked &&
      css`
        background: ${color};
        border: 2px solid ${color};
      `
    );
  }}
`;

export const InputLabel = styled.label`
  ${({ disabled, isDarkMode }) => {
    const color = disabled ? colors.gray2 : isDarkMode ? colors.fsLightBlue : colors.darkBlue2;
    return css`
      color: ${color};
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `;
  }};
  font-weight: 400;
  margin-left: 8px;
  margin-bottom: 0px;
  font-size: 15px;
`;
